import React from 'react';
import { modelsData } from '../../constants/labV4Models';

const InfoModal = ({ isOpen, onClose }) => {
    if (!isOpen) return null;
    return (
        <div className="fixed inset-0 bg-black/80 backdrop-blur-sm flex items-center justify-center z-50 p-4" onClick={onClose}>
            <div className="bg-gray-800 rounded-xl border border-gray-600 shadow-2xl overflow-hidden max-w-4xl w-full" onClick={e => e.stopPropagation()}>
                <div className="flex items-center justify-between p-4 border-b border-gray-700 bg-gray-900">
                    <h2 className="text-xl font-bold text-white">Model Information & Pricing</h2>
                    <button onClick={onClose} className="text-gray-400 hover:text-white text-3xl font-bold leading-none">&times;</button>
                </div>
                <div className="overflow-x-auto">
                    <table className="w-full text-left text-sm text-gray-300 pointer-events-none">
                        <thead className="text-xs uppercase bg-gray-900/50 text-gray-400 border-b border-gray-700">
                            <tr>
                                <th className="px-6 py-4 font-bold">Model Name</th>
                                <th className="px-4 py-4 font-bold">Input Cost (/1M)</th>
                                <th className="px-4 py-4 font-bold">Output Cost (/1M)</th>
                                <th className="px-4 py-4 font-bold">Context Window</th>
                                <th className="px-6 py-4 font-bold">Notes</th>
                            </tr>
                        </thead>
                        <tbody className="divide-y divide-gray-700">
                            {modelsData.map((m, i) => (
                                <tr key={i} className="hover:bg-gray-700/50 transition-colors">
                                    <td className="px-6 py-3 font-semibold text-blue-300">{m.name}</td>
                                    <td className="px-4 py-3">{m.inCost}</td>
                                    <td className="px-4 py-3">{m.outCost}</td>
                                    <td className="px-4 py-3"><span className="px-2 py-0.5 bg-emerald-900/30 text-emerald-400 rounded-md font-mono text-xs border border-emerald-800/50">{m.context}</span></td>
                                    <td className="px-6 py-3 text-xs text-gray-400 leading-snug">{m.notes}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
};

export default InfoModal;
